import React from "react"
import { generatePath, useNavigate } from "react-router-dom"
import { observer } from "mobx-react"
import { Table, Tag, Typography } from "antd"
import { ColumnsType } from "antd/es/table"

import { paths } from "@src/app/paths"
import { SubMerchCollection } from "@src/pages/settingsTeam/classes/SubMerchCollections"
import {
  SubmerchantResponse,
  SubmerchantResponseStatusEnum,
} from "@src/shared/api/generated"
import { WithCollection } from "@src/shared/classes/Collection/types"
import { WithCopy } from "@src/shared/componemts/WithCopy"
import { paddingLimit } from "@src/shared/strings"

export const SubMerchTable = observer(
  ({ collection }: WithCollection<SubMerchCollection>) => {
    const nav = useNavigate()

    const onRowClick = (row: SubmerchantResponse) => {
      nav(generatePath(paths.subMerchDetail, { id: row.id! }))
    }

    const columns: ColumnsType<SubmerchantResponse> = [
      {
        dataIndex: "id",
        render: (id: string) => (
          <Typography.Link>
            {
              <WithCopy
                content={id}
                style={{ justifyContent: "space-between" }}
                view={
                  <Typography.Link>{paddingLimit(id, 0, 6)}</Typography.Link>
                }
              />
            }
          </Typography.Link>
        ),
        title: "ID",
      },
      {
        dataIndex: "email",
        render: (_, { email }) => <Typography.Text>{email}</Typography.Text>,
        title: "Email",
      },
      {
        dataIndex: "access_control_groups",
        render: (_, { access_control_groups }) => (
          <Typography.Text>{access_control_groups.join(", ")}</Typography.Text>
        ),
        title: "Access",
      },
      {
        dataIndex: "status",
        render: (_, { status }) => {
          const cMap = {
            [SubmerchantResponseStatusEnum.Blocked]: "error",
            [SubmerchantResponseStatusEnum.Confirmed]: "green",
            [SubmerchantResponseStatusEnum.Pending]: "warning",
            [SubmerchantResponseStatusEnum.Unconfirmed]: "default",
          }

          return <Tag color={cMap[status!] ?? "geekblue"}>{status}</Tag>
        },
        title: "Status",
      },
    ]

    return (
      <Table
        columns={columns}
        dataSource={collection.items}
        loading={collection.isLoading}
        onRow={(record) => {
          return {
            onClick: () => onRowClick(record),
          }
        }}
        pagination={collection.pagination}
        rowKey="id"
      />
    )
  },
)
